<div class="wrapper">
  <app-usage-details [data]="data"/>
  <app-actions-section
    class="actions-section w-[455px]"
    [disableAddMenu]="disableAddMenu"
    locationStationToolbarContext="usage"
  />
</div>
